export default __webpack_public_path__ + "static/media/Intro2React.9755d47f.jpg";